"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TENANT_ID = exports.METRICS = void 0;
exports.METRICS = {
    CATALYST_CREATE_CASE_ERROR: {
        COUNT: 'catalystCreateCaseApiErr.ct',
        LATENCY: 'catalystCreateCaseApiErr.lat'
    },
    CATALYST_CREATE_CASE_SUCCESS: {
        COUNT: 'catalystCreateCaseApi.ct',
        LATENCY: 'catalystCreateCaseApi.lat'
    },
    CATALYST_GET_UPLOAD_URL_ERROR: {
        COUNT: 'catalystGetUploadUrlApiErr.ct',
        LATENCY: 'catalystGetUploadUrlApiErr.lat'
    },
    CATALYST_GET_UPLOAD_URL_SUCCESS: {
        COUNT: 'catalystGetUploadUrlApi.ct',
        LATENCY: 'catalystGetUploadUrlApi.lat'
    },
    PUNCH_FEATURE: {
        COUNT: 'punchFt.ct',
        LATENCY: 'punchFt.lat'
    },
    PUNCH_CORR_STATUS_LIST: {
        COUNT: 'punchCorrStat.ct',
        LATENCY: 'punchCorrStat.lat'
    },
    PUNCH_SECTION_V2: {
        COUNT: 'punchSecV2.ct'
    },
    PUNCH_DETAILS: {
        COUNT: 'punchDets.ct'
    },
    TIMECARD_FEATURE: {
        COUNT: 'timecdFt.ct',
        LATENCY: 'timecdFt.lat'
    },
    TIMECARD_LINK: {
        COUNT: 'timecdLink.ct'
    },
    TIMECARD_LINK_CLICKED: {
        COUNT: 'timecdLinkClk.ct'
    },
    MISSED_PUNCH_MODAL: {
        COUNT: 'missPunchOpnd.ct'
    },
    MISSED_PUNCH_MODAL_FROM_CLICKABLE_ROW: {
        COUNT: 'missPunchModalFromRow.ct'
    },
    PUNCH_CORRECTION_MODAL: {
        COUNT: 'punchCorrOpnd.ct'
    },
    PUNCH_DELETE_BUTTON: {
        COUNT: 'punchDltBtn.ct'
    },
    PUNCH_DELETE_REQUEST_SUCCESS: {
        COUNT: 'punchDltRqSucc.ct'
    },
    PUNCH_DELETE_REQUEST_ERROR: {
        COUNT: 'punchDltRqErr.ct'
    },
    PUNCH_EDIT_MODAL: {
        COUNT: 'punchEdOpnd.ct'
    },
    PUNCH_EDIT_BUTTON: {
        COUNT: 'punchEdBtn.ct'
    },
    PUNCH_EDIT_LIMIT_LOCKOUT: {
        COUNT: 'punchEdLimLo.ct'
    },
    PUNCH_EDIT_REQUEST_NON_HISTORICAL_SUCCESS: {
        COUNT: 'punchEdNonHistRqSucc.ct'
    },
    PUNCH_EDIT_REQUEST_NON_HISTORICAL_ERROR: {
        COUNT: 'punchEdNonHistRqErr.ct'
    },
    PUNCH_EDIT_REQUEST_HISTORICAL_SUCCESS: {
        COUNT: 'punchEdHistRqSucc.ct'
    },
    PUNCH_EDIT_REQUEST_HISTORICAL_ERROR: {
        COUNT: 'punchEdHistRqErr.ct'
    },
    MISSED_PUNCH_REQUEST_NON_HISTORICAL_SUCCESS: {
        COUNT: 'missPunchNonHistRqSucc.ct'
    },
    MISSED_PUNCH_REQUEST_NON_HISTORICAL_ERROR: {
        COUNT: 'missPunchNonHistRqErr.ct'
    },
    MISSED_PUNCH_REQUEST_HISTORICAL_SUCCESS: {
        COUNT: 'missPunchHistRqSucc.ct'
    },
    MISSED_PUNCH_REQUEST_HISTORICAL_ERROR: {
        COUNT: 'missPunchHistRqErr.ct'
    },
    MISSED_PUNCH_LIMIT_LOCKOUT: {
        COUNT: 'missPunchLimLo.ct'
    },
    PUNCH_EDIT_MEAL_LOCKOUT_NON_HISTORICAL: {
        COUNT: 'punchEdMealLoNonHist.ct'
    },
    PUNCH_EDIT_MEAL_LOCKOUT_HISTORICAL: {
        COUNT: 'punchEdMealLoHist.ct'
    },
    TIMECARD_REQUEST_CORR_LINK: {
        COUNT: 'timecdRqCorrLink.ct'
    },
    REQUEST_CORR_IN_TIMECARD: {
        COUNT: 'timecdRqCorr.ct'
    },
    SUBMIT_PUNCH_APPROVAL_REVIEW_SUCCESS: {
        COUNT: 'punchReviewRqSucc.ct'
    },
    SUBMIT_PUNCH_APPROVAL_REVIEW_ERROR: {
        COUNT: 'punchReviewRqErr.ct'
    },
    TIMECARD_REQUEST_CORR_ATTENDANCE: {
        COUNT: 'timecdRqCorrAttn.ct'
    },
    TIMECARD_REQUEST_CORR_TIME_OFF: {
        COUNT: 'timecdRqCorrTimeOff.ct'
    },
    TIMECARD_REQUEST_CORR_PUNCH_CORR: {
        COUNT: 'timecdRqCorrPunchCorr.ct'
    },
    TIMECARD_REQUEST_CORR_ABSENCE_LATENESS: {
        COUNT: 'timecdRqCorrAbsLate.ct'
    },
    TIMECARD_REQUEST_CORR_PUNCHES: {
        COUNT: 'timecdCorrPunches.ct'
    },
    TIMECARD_SEE_PAY_LINK_SEEN: {
        COUNT: 'seePayLinkSeen.ct'
    },
    TIMECARD_SEE_PAY_LINK_CLICK: {
        COUNT: 'seePayLinkClk.ct'
    },
    TASK_LIST: {
        COUNT: 'taskLst.ct',
        LATENCY: 'taskLst.lat'
    },
    TASK_LIST_BACK_TIMECARD_CLICK: {
        COUNT: 'taskLstBackTCClk.ct'
    },
    TASK_LIST_PUNCH_STATUS_CORRECTION_NOT_ACCEPTED_CLICK: {
        COUNT: 'taskLstPunchCorrNotAcptClk.ct'
    },
    TASK_LIST_PUNCH_STATUS_CORRECTION_PENDING_CLICK: {
        COUNT: 'taskLstPunchCorrPndgClk.ct'
    },
    TASK_LIST_PUNCH_STATUS_CORRECTION_COMPLETED_CLICK: {
        COUNT: 'taskLstPunchCorrComplClk.ct'
    },
    TASK_LIST_CLOSE_PUNCH_CORRECTION_STATUS_MODAL: {
        COUNT: 'taskLstClsCorrStat.ct'
    },
    TASK_LIST_DUPLICATE_PUNCH_CLICK: {
        COUNT: 'taskLstDupPunchClk.ct'
    },
    TASK_LIST_MISSING_PUNCH_CLICK: {
        COUNT: 'taskLstMissPunchClk.ct'
    },
    TASK_LIST_SYSTEM_ADDED_PUNCH_CLICK: {
        COUNT: 'taskLstSystAddPunchClk.ct'
    },
    TASK_LIST_LINK_IN_TIMECARD: {
        COUNT: 'taskLstLinkInTCd.ct'
    },
    TASK_LIST_LINK_IN_TIMECARD_CLICKED: {
        COUNT: 'taskLstLinkInTCdClk.ct'
    },
    TASK_LIST_LINK_IN_PUNCH_SECTION: {
        COUNT: 'taskLstLnkInPunch.ct'
    },
    TASK_LIST_LINK_IN_PUNCH_SECTION_CLICKED: {
        COUNT: 'taskLstLinkInPSClk.ct'
    },
    TASK_LIST_LEARN_MORE_CLICKED: {
        COUNT: 'taskLstLearnMoreClk.ct'
    },
    UNKNOWN_ERROR: {
        COUNT: 'unknownErr.ct'
    },
    FES_POLICY_MISSING_FEATURE_COUNT: {
        COUNT: 'missingFes.ct'
    },
    PAY_CODES_ADD: {
        COUNT: 'addPayCode.ct'
    },
    PAY_CODES_ADD_ERROR: {
        COUNT: 'addPayCodeErr.ct'
    },
    PAY_CODES_EDIT: {
        COUNT: 'edPayCode.ct'
    },
    PAY_CODES_EDIT_ERROR: {
        COUNT: 'edPayCodeErr.ct'
    },
    HOURLY_BREAKDOWN_FEATURE: {
        COUNT: 'hrlyBdFt.ct',
        LATENCY: 'hrlyBdFt.lat'
    },
    SELF_CLASSIFICATION_ADD_BUTTON_RENDER: {
        COUNT: 'selfClassifAddBtn.ct'
    },
    SELF_CLASSIFICATION_ADD_BUTTON_CLICK: {
        COUNT: 'selfClassifAddBtnClk.ct'
    },
    SELF_CLASSIFICATION_EDIT_BUTTON_RENDER: {
        COUNT: 'selfClassifEdBtn.ct'
    },
    SELF_CLASSIFICATION_EDIT_BUTTON_CLICK: {
        COUNT: 'selfClassifEdBtnClk.ct'
    },
    ATPLUS_SELF_CLASSIFICATION_EMPTY_PAYCODES_LIST: {
        COUNT: 'ATPSelfClassifNoPayCodes.ct'
    },
    ATPLUS_SELF_CLASSIFICATION_ADD_BUTTON_RENDER: {
        COUNT: 'ATPSelfClassifAddBtn.ct'
    },
    ATPLUS_SELF_CLASSIFICATION_ADD_BUTTON_CLICK: {
        COUNT: 'ATPSelfClassifAddBtnClk.ct'
    },
    ATPLUS_SELF_CLASSIFICATION_EDIT_BUTTON_RENDER: {
        COUNT: 'ATPSelfClassifEdBtn.ct'
    },
    ATPLUS_SELF_CLASSIFICATION_EDIT_BUTTON_CLICK: {
        COUNT: 'ATPSelfClassifEdBtnClk.ct'
    },
    SELF_CLASSIFICATION_SUBMIT_UPDATE_PAYDATA_CLICK: {
        COUNT: 'selfClassifAddPayDtRq.ct'
    },
    ATPLUS_SELF_CLASSIFICATION_SUBMIT_ADD_PAYCODE_CLICK: {
        COUNT: 'ATPSelfClassifAddPayCodeRq.ct'
    },
    ATPLUS_SELF_CLASSIFICATION_SUBMIT_EDIT_PAYCODE_CLICK: {
        COUNT: 'ATPSelfClassifEdPayCodeRq.ct'
    },
    DELETE_AIP_BUTTON_RENDER: {
        COUNT: 'dltAIPBtn.ct'
    },
    DELETE_AIP_BUTTON_CLICK: {
        COUNT: 'dltAIPBtnClk.ct'
    },
    PUNCH_CORRECTION_CARD: {
        COUNT: 'punchCorrCd.ct'
    },
    PUNCH_CORRECTION_CARD_WITH_DELETE: {
        COUNT: 'punchCorrCdWithDlt.ct'
    },
    PUNCH_CORRECTION_CARD_CONFIRM_BUTTON_CLICK: {
        COUNT: 'punchCorrCdCfmBtnClk.ct'
    },
    PUNCH_CORRECTION_CARD_EDIT_BUTTON_CLICK: {
        COUNT: 'punchCorrCdEdBtnClk.ct'
    },
    PUNCH_CORRECTION_CARD_DELETE_BUTTON_CLICK: {
        COUNT: 'punchCorrCdDltBtnClk.ct'
    },
    PUNCH_CORRECTION_CARD_DELETE_BUTTON_SUBMIT: {
        COUNT: 'punchCorrCdDltBtnSbm.ct'
    },
    PUNCH_WORKFLOW: {
        COUNT: 'punchWF.ct',
        LATENCY: 'punchWF.lat'
    },
    PUNCH_WORKFLOW_SELECT_DATE_STEP_RENDERED: {
        COUNT: 'punchWFSelDate.ct'
    },
    PUNCH_WORKFLOW_SELECT_ACTION_STEP_RENDERED: {
        COUNT: 'punchWFSelAct.ct'
    },
    PUNCH_WORKFLOW_SELECT_ACTION_ADD: {
        COUNT: 'punchWFSelActAdd.ct'
    },
    PUNCH_WORKFLOW_SELECT_ACTION_EDIT: {
        COUNT: 'punchWFSelActEd.ct'
    },
    PUNCH_WORKFLOW_SELECT_ACTION_DELETE: {
        COUNT: 'punchWFSelActDel.ct'
    },
    PUNCH_WORKFLOW_SELECT_PUNCH_STEP_RENDERED: {
        COUNT: 'punchWFSelPunch.ct'
    },
    PUNCH_WORKFLOW_ADD_PUNCH_STEP_RENDERED: {
        COUNT: 'punchWFAddPunch.ct'
    },
    PUNCH_WORKFLOW_EDIT_PUNCH_STEP_RENDERED: {
        COUNT: 'punchWFEdPunch.ct'
    },
    PUNCH_WORKFLOW_REVIEW_STEP_RENDERED: {
        COUNT: 'punchWFReview.ct'
    },
    PUNCH_WORKFLOW_SUBMIT_MISS_PUNCH: {
        COUNT: 'punchWFSbmMissPunch.ct'
    },
    PUNCH_WORKFLOW_SUBMIT_EDIT_PUNCH: {
        COUNT: 'punchWFSbmEdtPunch.ct'
    },
    PUNCH_WORKFLOW_SUBMIT_DELETE_PUNCH: {
        COUNT: 'punchWFSbmDltPunch.ct'
    },
    PUNCH_WORKFLOW_CLOSE_BUTTON_CLICK: {
        COUNT: 'punchWFCloseBtnClk.ct'
    },
    REPORT_TRAVEL_TIME_WORKFLOW_FEATURE: {
        COUNT: 'reportTravelTimeWF.ct',
        LATENCY: 'reportTravelTimeWF.lat'
    },
    REPORT_TRAVEL_TIME_PAGE_RENDERED: {
        COUNT: 'reportTravelTimeWF.ct'
    },
    REPORT_TRAVEL_TIME_REVIEW_PAGE_RENDERED: {
        COUNT: 'reportTravelTimeReviewWF.ct'
    },
    PAYPERIOD_ACKNOWLEDGEMENT_SUCCESS: {
        COUNT: 'payPeriodAckRqstSuccess.ct'
    },
    PAYPERIOD_ACKNOWLEDGEMENT_ERROR: {
        COUNT: 'payPeriodAckRqstError.ct'
    },
    REPLACE_VTO_FEATURE: {
        COUNT: 'taskLst.ct',
        LATENCY: 'taskLst.lat'
    },
    PAYPERIOD_ACKNOWLEDGEMENT_BUTTON_CLICK: {
        COUNT: 'payPeriodAckButtonClick.ct'
    },
    REPLACE_VTO_WORKFLOW_PAGE_VISIT_COUNT: {
        COUNT: 'replaceVTOWorkflowVisitCount.ct'
    },
    REPLACE_VTO_WORKFLOW_SUBMIT_BUTTON_CLICK: {
        COUNT: 'replaceVTOWorkflowButtonClick.ct'
    },
    REPLACE_VTO_WORKFLOW_REQUESTS_COUNT: {
        COUNT: 'replaceVTOWorkflowRequestsCount.ct'
    },
    REPLACE_VTO_FORM_RENDERED: {
        COUNT: 'replaceVTOForm.ct'
    },
    REPLACE_VTO_WORKFLOW_NUMBER_OF_VTO_SUBMITTED: {
        COUNT: 'replaceVTOWorkflowNumberOfVTORequestsSubmitted.ct'
    }
};
exports.TENANT_ID = 'taaCompnt';
